"use client";

import { RahuKaal } from "@/components/rahu-kaal";
import type { MuhuratResponse } from "@/lib/api/muhurat";

export default function RahuKaalClient({
  defaultCity = "New Delhi",
  initialDate,
  initialResult,
}: {
  defaultCity?: string;
  initialDate?: string;
  initialResult?: MuhuratResponse | null;
}) {
  return (
    <div className="intent-interface-timing-first min-h-[calc(100vh-130px)]">
      <RahuKaal defaultCity={defaultCity} initialDate={initialDate} initialResult={initialResult} />
    </div>
  );
}
